import React from "react";

import DenominacionTarjeta from "./Edicion/DenominacionTarjeta";
import CuartaLineaTarjeta from "./Edicion/CuartaLineaTarjeta";
import TipoTarjeta from "./Edicion/TipoTarjeta";
import EsTarjetaTemporal from "./Edicion/EsTarjetaTemporal";
import LimiteCompraTarjeta from "./Edicion/LimiteCompraTarjeta";
import CodigoDistribucion from "./Edicion/CodigoDistribucion";
//import MensajeTarjeta from "./Edicion/MensajeTarjeta";

const TableRowEdicion = (props) => {
    /*Atributos*/
    const { data, filaEnModoEdicion, funciones, tarjeta, tarjetas, tieneAlgunaNovedad } = props;
    let claseTieneNovedad = ((tieneAlgunaNovedad && data.funcionesDelUsuario.Confirmacion == true) ? "fila-con-novedad-tarjetas" : "");

    if (filaEnModoEdicion == false) {
        claseTieneNovedad += " closed";
    }
    let paneles = [];
    //paneles.push(<MensajeTarjeta mostrarMensaje={seIntentaEditar} mensaje="Debe finalizar la edición antes de continuar." />);

    paneles.push(
        <DenominacionTarjeta data={data}
            tarjeta={tarjeta}
            codigoNovedad="DENOM_TARJ"
            changeInput={funciones.changeInput}
            estadoEdicion={funciones.estadoEdicion}
            guardarNovedad={funciones.guardarNovedad}
            cancelar={funciones.cancelar}
            mostrarModal={() => funciones.mostrarModal(true, "Denominacion de la tarjeta", data.entidadTipo, "DENOM_TARJ", tarjeta.TarjetaCreditoId)}
            actualizarNovedadEstado={funciones.actualizarNovedadEstado}
        />
    );

    paneles.push(
        <CuartaLineaTarjeta data={data}
            tarjeta={tarjeta}
            codigoNovedad="CRLIN_TARJ"
            changeInput={funciones.changeInput}
            estadoEdicion={funciones.estadoEdicion}
            guardarNovedad={funciones.guardarNovedad}
            cancelar={funciones.cancelar}
            mostrarModal={() => funciones.mostrarModal(true, "Cuarta Linea", data.entidadTipo, "CRLIN_TARJ", tarjeta.TarjetaCreditoId)}
            actualizarNovedadEstado={funciones.actualizarNovedadEstado}
        />
    );

    paneles.push(
        <TipoTarjeta data={data}
            tarjeta={tarjeta}
            codigoNovedad="TITAR_TARJ"
            selectCombo={funciones.selectCombo}
            estadoEdicion={funciones.estadoEdicion}
            guardarNovedad={funciones.guardarNovedad}
            cancelar={funciones.cancelar}
            mostrarModal={() => funciones.mostrarModal(true, "Tipo Tarjeta", data.entidadTipo, "TITAR_TARJ", tarjeta.TarjetaCreditoId)}
            actualizarNovedadEstado={funciones.actualizarNovedadEstado}
        />
    );

    paneles.push(
        <EsTarjetaTemporal data={data}
            tarjeta={tarjeta}
            codigoNovedad="ESTEM_TARJ"
            changeCheck={funciones.changeCheck}
            selectCombo={funciones.selectCombo}
            estadoEdicion={funciones.estadoEdicion}
            guardarNovedad={funciones.guardarNovedad}
            cancelar={funciones.cancelar}
            mostrarModal={() => funciones.mostrarModal(true, "Tarjeta Temporal", data.entidadTipo, "ESTEM_TARJ", tarjeta.TarjetaCreditoId)}
            mostrarModalHijo={funciones.mostrarModal}
            actualizarNovedadEstado={funciones.actualizarNovedadEstado}
            getDiasVigencia={funciones.getDiasVigencia}
        />
    );

    if (tarjeta.ModalidadDistribucionLimiteId > 1) {
        paneles.push(<LimiteCompraTarjeta tarjeta={tarjeta} tarjetas={tarjetas} />);
    }

    paneles.push(<CodigoDistribucion tarjeta={tarjeta} />);

    return <tr key={"table-row-edition-tarjeta-" + tarjeta.TarjetaCreditoId} className={claseTieneNovedad}>
        <td colSpan="7" className="no-padding">
            <div className={("slider-tarjetas " + ((filaEnModoEdicion == false) ? "closed" : ""))}>
                {paneles}
            </div>
        </td>
    </tr>
}

export default TableRowEdicion;